function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 12.943l2.787-3.55c.225-.287.628-.435 1.02-.383L25 9.87 21.974 14 15 12.943zM27.548 7.21a.968.968 0 00-1.345.303l-.155.245c-.069-.029-.134-.067-.212-.08L19.42 6.638a2.915 2.915 0 00-2.877 1.255l-4.013 5.955a.972.972 0 01-.965.418l-3.104-.527 2.557-1.823a.99.99 0 00.41-.878l-.212-2.877 2.578.438a.975.975 0 001.123-.808.985.985 0 00-.8-1.134l-3.805-.645A.979.979 0 009.18 7.056l.264 3.572-4.037 2.879a.978.978 0 00-.402.642l-.001.002c-.006.032.005.062.003.092a.987.987 0 00.01.288.981.981 0 00.13.3c.01.016.01.035.022.05h.002c.081.12.194.212.321.284.044.024.09.035.136.052.059.023.112.058.176.069l5.44.92a2.923 2.923 0 002.899-1.251l.187-.277 6.63 1.17-5.145 8.183h-1.007a.98.98 0 00-.974.985.98.98 0 00.974.984h3.907a.98.98 0 00.974-.984.98.98 0 00-.974-.985h-.59l9.724-15.464a.99.99 0 00-.3-1.358z",
  fill: "#000",
  fillRule: "evenodd"
});

function SvgIcReversedGeocode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgIcReversedGeocode;